import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { User } from 'src/types/shared/User';

export const fetchSingleSuperAdminUserRequest = createAction('fetchSingleSuperAdminUserRequest');
export const fetchSingleSuperAdminUserSuccess = createAction<User>(
    'fetchSingleSuperAdminUserSuccess',
);
export const fetchSingleSuperAdminUserFailure = createAction('fetchSingleSuperAdminUserFailure');

export const fetchSingleSuperAdminUser = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchSingleSuperAdminUserRequest());
    try {
        const { data }: UserResponse = await api.get(`admin/superadmins/${id}`);
        dispatch(fetchSingleSuperAdminUserSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchSingleSuperAdminUserFailure, e);
    }
};

interface UserResponse {
    data: User;
}
